import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export function ActionButton(props) {
  const { em, app } = props;
  const { handlers } = app || {};
  const floating = (em && em.floating) || false;

  const handleDefaultClick = useCallback(
    (e) => {
      if (!handlers) {
        console.error("'handlers' is not found. 'app' property with 'handlers' must be assigned");
        console.info('<ActionButton em={...} app={...} />\nor pass though ZectionGroup');
      }
    },
    [handlers]
  );

  return (<>
    {floating && <React.Fragment><label>&nbsp;</label><br /></React.Fragment>}
    <button
      type="button"
      onClick={em.click && handlers && handlers[em.click] ? handlers[em.click] : handleDefaultClick}
      className={'btn btn-sm mx-1 btn-' + (em.color || 'info') + (em.icon ? ' btn-icon-split' : '') + ` ${em.class || ''}`}
    >
      {em.icon && (
        <React.Fragment>
          <span className="icon text-white">
            <i className={em.icon}></i>
          </span>
          <span className="text d-none d-sm-inline">{em.label}</span>
        </React.Fragment>
      )}
      {em.icon ? null : em.label}
    </button>
    </>);
}

ActionButton.propTypes = {
  app: PropTypes.any,
  em: PropTypes.any,
}